import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import defaultUserPhoto from '../../../images/default_user.png';

export default class Avatar extends PureComponent {
  render () {
    return (
      <div
        className={`image-icon ${this.props.className}`}
        style={{ backgroundImage: `url('${this.props.photo_image_url || defaultUserPhoto}')` }}
      />
    );
  }
}

Avatar.propTypes = {
  photo_image_url: PropTypes.string,
  className: PropTypes.string
};

Avatar.defaultProps = {
  className: ''
};



// WEBPACK FOOTER //
// ./src/components/common/ui/Avatar.js